import { Tool } from "@/types";

interface SchemaMarkupProps {
  tools?: Tool[];
  currentTool?: Tool;
  isToolPage?: boolean;
}

export const SchemaMarkup = ({ tools, currentTool, isToolPage }: SchemaMarkupProps) => {
  const baseUrl = "https://diraya.ai";

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "دراية - Diraya.AI",
    "url": baseUrl,
    "description": "الدليل الشامل لأدوات الذكاء الاصطناعي باللغة العربية",
    "inLanguage": "ar",
    "publisher": {
      "@type": "Organization",
      "name": "دراية - Diraya.AI",
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/icon-512x512.png`,
        "width": "512",
        "height": "512"
      },
      "sameAs": [
        "https://twitter.com/BoDresha"
      ]
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  const toolListSchema = tools ? {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": tools.map((tool, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "SoftwareApplication",
        "name": tool.name,
        "description": tool.description,
        "image": tool.imageUrl,
        "url": `${baseUrl}/tool/${tool.id}`,
        "applicationCategory": "AI Tool",
        "operatingSystem": "Web",
        "datePublished": tool.created_at,
        "dateModified": tool.updated_at,
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        },
        "inLanguage": "ar",
        "author": {
          "@type": "Organization",
          "name": "دراية - Diraya.AI"
        }
      }
    }))
  } : null;

  const toolSchema = currentTool && isToolPage ? {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": currentTool.name,
    "description": currentTool.description,
    "image": currentTool.imageUrl,
    "url": `${baseUrl}/tool/${currentTool.id}`,
    "applicationCategory": "AI Tool",
    "operatingSystem": "Web",
    "category": currentTool.categories.join(", "),
    "datePublished": currentTool.created_at,
    "dateModified": currentTool.updated_at,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "aggregateRating": currentTool.likes ? {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": currentTool.likes
    } : undefined,
    "review": currentTool.usage_guide ? {
      "@type": "Review",
      "reviewBody": currentTool.usage_guide,
      "author": {
        "@type": "Organization",
        "name": "دراية - Diraya.AI"
      }
    } : undefined,
    "inLanguage": "ar",
    "author": {
      "@type": "Organization",
      "name": "دراية - Diraya.AI"
    }
  } : null;

  const breadcrumbSchema = isToolPage && currentTool ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "الرئيسية",
        "item": baseUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "الأدوات",
        "item": `${baseUrl}/tools`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": currentTool.name,
        "item": `${baseUrl}/tool/${currentTool.id}`
      }
    ]
  } : null;

  return (
    <script type="application/ld+json">
      {JSON.stringify(isToolPage ? 
        { 
          "@context": "https://schema.org",
          "@graph": [websiteSchema, toolSchema, breadcrumbSchema]
        } : { 
          "@context": "https://schema.org",
          "@graph": [websiteSchema, toolListSchema]
        }
      )}
    </script>
  );
};